import { cn } from '../../lib/cn';

const POLE_COLORS: Record<string, string> = {
  Affaires: 'bg-blue-100 text-blue-700',
  Famille: 'bg-violet-100 text-violet-700',
  // Ambre et non rouge/rose : le rouge est réservé à l'étiquette « nouvelle demande » (Julien, 21/07).
  Pénal: 'bg-amber-100 text-amber-800',
  Public: 'bg-teal-100 text-teal-700',
};

export function getPoleColor(pole: string | null | undefined): string {
  if (!pole) return 'bg-neutral-100 text-neutral-600';
  return POLE_COLORS[pole] ?? 'bg-neutral-100 text-neutral-600';
}

interface TicketPoleBadgeProps {
  pole: string | null | undefined;
  className?: string;
}

export function TicketPoleBadge({ pole, className }: TicketPoleBadgeProps) {
  if (!pole) {
    return (
      <span
        className={cn(
          'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-neutral-100 text-neutral-400',
          className,
        )}
      >
        —
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        getPoleColor(pole),
        className,
      )}
    >
      {pole}
    </span>
  );
}
